import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
	useTheme,
} from "@material-ui/core/styles";
import {
	Grid,
	Paper,
	PaperProps,
	Typography,
	IconButton,
} from "@material-ui/core";
import ReplayRoundedIcon from "@material-ui/icons/ReplayRounded";

// NPM
import { ReactSketchCanvas } from "react-sketch-canvas";

// Contexts
import { usePaymentManager } from "../../contexts/PaymentManager.Context";

// Classes
import Utility from "../../domain/classes/Utility";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(1),
			height: theme.spacing(22),
			maxWidth: theme.spacing(38),
			margin: "auto",
			border: `1px solid ${theme.palette.primary.main}`,
			marginTop: theme.spacing(4),
		},
		cardElementsContainer: {
			display: "flex",
			height: "100%",
			justifyContent: "center",
			flexFlow: "column",
			position: "relative",
		},
		termsAndConditions: {
			cursor: "pointer",
			"&:hover": {
				textDecoration: "underline",
			},
		},
		flipButton: {
			position: "absolute",
			top: 0,
			right: 0,
		},
	});

export interface CreditCardBackProps extends PaperProps {}

const CreditCardBack = React.forwardRef<
	HTMLDivElement,
	CreditCardBackProps & WithStyles<typeof styles>
>(({ classes, className, ...paperProps }, ref) => {
	const theme = useTheme();

	const { handleCardFlippedChange } = usePaymentManager();

	const { canvasRef } = usePaymentManager();

	return (
		<Paper
			className={classes.root}
			{...paperProps}
			component="div"
			ref={ref}
		>
			<Grid
				container
				spacing={1}
				className={classes.cardElementsContainer}
			>
				<IconButton
					size="small"
					className={classes.flipButton}
					onClick={() => handleCardFlippedChange(false)}
				>
					<ReplayRoundedIcon fontSize="small" />
				</IconButton>
				<Typography variant="caption">Signature</Typography>
				<ReactSketchCanvas
					ref={canvasRef}
					style={{
						height: 120,
						border: "1px solid #DFDFDF",
						marginTop: 8,
						marginBottom: 8,
					}}
					strokeColor={theme.palette.primary.main}
					strokeWidth={2}
					withTimestamp
				/>
			</Grid>
		</Paper>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CreditCardBack"),
})(CreditCardBack);
